import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { webCrawlingForResearch } from '../../assets/data/features/web-crawling-for-research';

export const Route = createFileRoute('/_marketing/web-crawling-for-research')({
  component: () => <FeatureArticle data={webCrawlingForResearch} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(webCrawlingForResearch),
  }),
  head: basicHead,
});
